const text=`<div><br></div><div><br></div><div>&lt;--- Try resizing the content box by this middle line as well<br></div><div><br></div><div><br></div>`;
export default text;